export default __webpack_public_path__ + "static/media/volume-filled-lime.9f64cca6.svg";